<template>
    <div class="thank-you-message">
        <el-dialog 
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            :center="true"
            :top="'0'"
            :show-close="false" 
            custom-class="thank-you-message__dialog"
        >
            <div class="thank-you-message__dialog__header">
                <div class="thank-you-message__dialog__close" @click="closeClickHandler">
                    <icon><IconClose/></icon>
                </div>
            </div>
            <div class="thank-you-message__dialog__body">
               <div class="copy-bold black thank-you-message__dialog__title">Vielen Dank für Ihre Mithilfe! </div>
               <div class="copy">Ihre Preise wurden übermittelt. Nach interner Prüfung werden die gemeldeten Preise veröffentlicht.</div>
               <SmrButton class="black thank-you-message__dialog__button" @click.native="closeClickHandler">Verstanden</SmrButton>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import Icon from '@/components/Icon.vue'
    import IconClose from '@/components/icons/IconClose.vue'
    import SmrButton from '@/components/SmrButton.vue'
    import eventBus from '@/utils/event-bus'

    export default {
        components: {
            Icon,
            IconClose,
            SmrButton,
        },
        data() {
            return {
                dialogVisible: false,
            }
        },
        mounted() {
            this.addListeners();
        },
        beforeDestroy() {
            this.removeListeners()
        },
        methods: {
            closeClickHandler() {
                this.dialogVisible = false;
            },
            showDialog() {
                this.dialogVisible = true;
            },
            addListeners() {
                eventBus.$on('thankYouMessage', this.showDialog);
            },
            removeListeners() {
                eventBus.$off('thankYouMessage', this.showDialog);
            }
        }
    }
</script>
<style lang="scss">
.thank-you-message {
    $block: &;

    &__dialog {
        width: calc(100% - 32px);
        top: 50%;
        transform: translateY(-50%);
        border-radius: $standard-border-radius;

        @include mq(tablet) {
            max-width: 500px;
        }

         .el-dialog {
            &__wrapper {
                background: transparent;
            }

            &__header {
                display: none;
            }

            &__body {
                padding: 0;
                word-break: initial;
                font-size: 15px;
            }
        }

        &__header {
            padding: 16px 16px 0 16px;
            display: flex;
            justify-content: flex-end;
        }

        &__body {
            padding: 0 24px 24px;
            
            @include mq(tablet) {
                padding: 0 30px 30px;
            }
        }

        &__close {
            display: flex;
            color: $color-grey-dark;
            transition: 0.2s;
            cursor: pointer;
        }

        &__title {
            margin-bottom: 12px;
        }

        &__button {
            margin-top: 24px;
        }
    }
}

</style>
